import { computed, ref, unref, toRef } from 'vue';
import { toBase64 } from '../helpers/toBase64';
import { handleAppOctetStreamResponse } from '../../../helpers/docDownload';
import kebabCase from 'lodash-es/kebabCase';
import mime from 'mime';
import is from '@sindresorhus/is';

export const useDccsForm = (props, captchaSolution) => {
    const busy = ref(false);

    const appendFromUrl = toRef(props, 'appendFromUrl');

    /**
     * This method transforms the VeeValidate Form's raw data to something that our api can consume.
     *
     * @param rawData {Object} The form fields raw data.
     * @returns {Promise<{}>}
     */
    const generateFormPayload = async rawData => {
        let payload = {};

        for await (const [key, value] of Object.entries(rawData)) {
            if (value instanceof File ) {
                if(document.getElementById('resetAttach').value === 'false'){
                    const encodedFileData = await toBase64(value);
                    const fileExtension = mime.getExtension(value.type);
                    const sanitizedFileName = kebabCase(value.name.replace(/\.[^/.]+$/, ''));
                    var contentType = string_between_strings(':',';',encodedFileData);
                    payload['contentBody'] = encodedFileData;
                    payload['fileName'] = sanitizedFileName + '.' + fileExtension;
                    payload['contentType'] = contentType;
                }

            } else {
                payload[key] = value;
            }
        }

        if (unref(captchaSolution) !== null) {
            payload['frc-captcha-solution'] = unref(captchaSolution);
        }

        // Add a special parameter if needed so we can track form submissions better
        if (unref(appendFromUrl) === true) {
            payload['fromUrl'] = window.location.pathname;
        }

        return payload;
    };

    const redirectUrl = toRef(props, 'redirectUrl');
    const hasValidRedirectUrl = computed(() => {
        if (!redirectUrl.value) {
            return false;
        }

        return !!(
            redirectUrl.value.startsWith('/') ||
            (is.urlString(redirectUrl.value) && redirectUrl.value.startsWith('https://www.dccs.eu/'))
        );
    });
    const normalizedRedirectUrl = computed(() => (hasValidRedirectUrl.value === true ? unref(redirectUrl) : null));

    const handleDownloadResponse = response => {
        handleAppOctetStreamResponse(response);
    };

    return {
        busy,
        generateFormPayload,
        hasValidRedirectUrl,
        normalizedRedirectUrl,
        handleDownloadResponse,
    };
};

function string_between_strings(startStr,endStr,str){
    var pos = str.indexOf(startStr) + startStr.length;
    return str.substring(pos,str.indexOf(endStr,pos));
}
